import { twMerge } from 'tailwind-merge';
import type { TableProps } from '../../Table';
import TableHeader from './table-head-components/TableHeader';

export type TableHeadProps<Row> = Pick<TableProps<Row>, 'columns' | 'headerClassName'>;

export default function TableHead<Row>({ columns, headerClassName: generalHeaderClassName }: TableHeadProps<Row>) {
  return (
    <thead>
      <tr>
        {columns.map(({ accessor, header, headerClassName }, headerIndex) => (
          <TableHeader 
            key={headerIndex}
            {...{ header, accessor, headerClassName: twMerge(generalHeaderClassName, headerClassName) }}
          />
        ))}
      </tr>
    </thead>
  );
}